import { Header, Shared, HomePage } from "./language-map";

const languageEN = {
  ...Header,
  ...Shared,
  ...HomePage,
};

export default languageEN;
